import { useEffect } from 'react';
import { Box, Container, Grid } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { LOAN_PATH } from '@/config/loanNavPaths';
import { PROFILE_PATH } from '@/config/profileNavPaths';
import { ProfileDeleteAccount } from '@/components/Profile/ProfileDeleteAccount';
import { ProfilePersonalInformation } from '@/components/Profile/ProfilePersonalInformation';
import { ProfileSecurity } from '@/components/Profile/ProfileSecurity';
import { SubscriptionManagement } from '@/components/Profile/SubscriptionManagement';
import { EmailPreferences } from '@/components/Settings/EmailPreferences';

export const ProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (location.pathname !== '/profile') return;

    const tab = searchParams.get('tab');
    const next = new URLSearchParams(searchParams);
    next.delete('tab');
    const rest = next.toString();
    const suffix = rest ? `?${rest}` : '';

    if (tab === 'loan' || tab === '0') {
      navigate(`${LOAN_PATH.loanType}${suffix}`, { replace: true });
      return;
    }
    if (tab === '1') {
      navigate(`${LOAN_PATH.qualifications}${suffix}`, { replace: true });
      return;
    }

    const qs = searchParams.toString();
    navigate(
      { pathname: PROFILE_PATH.settings, search: qs ? `?${qs}` : '' },
      { replace: true }
    );
  }, [location.pathname, navigate, searchParams]);

  return (
    <Container maxWidth="lg" sx={{ py: '40px' }}>
      <Box sx={{ py: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <ProfilePersonalInformation />
          </Grid>
          <Grid item xs={12} md={6}>
            <ProfileSecurity />
          </Grid>
          <Grid item xs={12}>
            <SubscriptionManagement />
          </Grid>
          <Grid item xs={12}>
            <EmailPreferences />
          </Grid>
          <Grid item xs={12}>
            <ProfileDeleteAccount />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
